import { clsx } from '@alexis/helpers/clsx';
import React from 'react';

import styles from './ProgressBar.module.scss';

interface ProgressBarProps {
  progressPercent: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progressPercent }): JSX.Element => {
  return (
    <div
      data-testid='progressBar'
      className={clsx(styles.container, progressPercent === 100 && styles.hidden)}
    >
      <div
        className={clsx(styles.progressBar, progressPercent === 0 && styles.noTransition)}
        style={{ width: `${progressPercent}%` }}
      ></div>
    </div>
  );
};

export default React.memo(ProgressBar);
